/**
 * Copyright 2020 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const deleteNotificationGroup = `mutation DeleteNotificationGroup($customer_id: String!, $id: String!) {
    deleteNotificationGroup(customer_id: $customer_id, id: $id)
  }
  `;
